import React, { Component } from 'react';

import { Form, Select, Modal } from 'antd';

import services from './../../services'

const FormItem = Form.Item;

class SearchInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: undefined,
            maps: {},
            data: []
        }
    }

    componentDidMount() {
        
    }

    querySearch(value) {
        var params = {
            courseName: value,
            limitFlag: true
        };

        return services.course.querySearchByName(params)
        .then((data) => {
            this.maps = {};

            data.forEach(d => {
                this.maps[d.value] = d.label;
            });

            if(this.value) {
                this.setState({
                    value: this.maps[this.value || this.state.value]
                });
            } 
            this.setState({
                data
            });
        });
        
    }

    onFocus() {

    }

    onSearch(value) {
        this.querySearch(value);
    }

    onChange(value, data) {
        this.setState({ value });

        if(this.props.handleChange) {
            this.props.handleChange({
                courseId: value,
                courseName: this.maps[value]
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.value) {
            if(this.value !==  nextProps.value) {
                this.value = nextProps.value;
                this.setState({
                    value: nextProps.value
                });
                this.querySearch();
            }
        }
    }

    render() {
        const { style, name, label, rules, disabled, getFieldDecorator } = this.props;
        const { value } = this.state;
        const options = this.state.data.map(d => <Option key={d.value}>{d.label}</Option>);
        return (
            <FormItem label={label || "课程"}>
                
                {
                    getFieldDecorator ? (
                        getFieldDecorator(name, {
                            initialValue: value,
                            rules: rules || [{
                                required: true,
                                message: '请选择'+ label,
                            }],
                        })(
                            <Select
                                allowClear={true}
                                showSearch
                                disabled={disabled}
                                value={ value }
                                placeholder={'请选择...'}
                                style={style || {width: 240}}
                                defaultActiveFirstOption={false}
                                showArrow={false}
                                filterOption={false}
                                onSearch={this.onSearch.bind(this)}
                                onChange={this.onChange.bind(this)}
                                onFocus={this.onFocus.bind(this)}
                                notFoundContent={null}
                                dropdownMatchSelectWidth={false}
                            >
                                {options}
                            </Select>
                        )
                    ) : (
                        <Select
                            allowClear={true}
                            showSearch
                            disabled={disabled}
                            value={ value }
                            placeholder={'请选择...'}
                            style={style || {width: 240}}
                            defaultActiveFirstOption={false}
                            showArrow={false}
                            filterOption={false}
                            onSearch={this.onSearch.bind(this)}
                            onChange={this.onChange.bind(this)}
                            onFocus={this.onFocus.bind(this)}
                            notFoundContent={null}
                            dropdownMatchSelectWidth={false}
                        >
                            {options}
                        </Select>
                    )
                }
            </FormItem>
        );
    }
}

export default SearchInput;